export const timeFrameState = {
  ACTIVE: 1,
  INACTIVE: 2
};

export const roleByProcess = {
  1: "ADMINISTRATIVE_MANAGEMENT_LEADER",
  2: "BIOMEDICAL_MANAGEMENT_LEADER",
  3: "COMMERCIAL_MANAGEMENT_LEADER",
  4: "HUMAN_RESOURCES_MANAGEMENT_LEADER",
  5: "HSQ_MANAGEMENT_LEADER",
  6: "MARKETING_AND_PROMOTION_MANAGEMENT_LEADER",
  7: "CUSTOMER_SERVICE_MANAGEMENT_LEADER",
  8: "FINANCIAL_AND_ACCOUNTING_MANAGEMENT_LEADER",
  9: "PHARMACEUTICAL_MANAGEMENT_LEADER",
  10: "MANAGEMENT_DIRECTOR_LEADER",
  11: "FOREIGN_TRADE_DIRECTOR_LEADER",
  12: "TECHNICAL_DIRECTION_TECHNICAL_SUPPORT_LEADER",
  13: "SAFETY_AND_HEALTH_AT_WORK_LEADER",
  14: "FOREIGN_TRADE_MANAGEMENT_LEADER",
  15: "CUSTOMER_SERVICE_PHARMADIA_MANAGEMENT_LEADER"
};

/**
 * Líderes del módulo Partes interesadas por process.id.
 * Convención definitiva: SERALOGIN_PROCESS_LEADER_<proceso>.
 */
export const interestedPartiesLeaderRoleByProcess = {
  1: "SERALOGIN_PROCESS_LEADER_ADMINISTRATIVE_MANAGEMENT",
  2: "SERALOGIN_PROCESS_LEADER_BIOMEDICAL_MANAGEMENT",
  3: "SERALOGIN_PROCESS_LEADER_COMMERCIAL_MANAGEMENT",
  4: "SERALOGIN_PROCESS_LEADER_HUMAN_RESOURCES_MANAGEMENT",
  5: "SERALOGIN_PROCESS_LEADER_HSQ_MANAGEMENT",
  6: "SERALOGIN_PROCESS_LEADER_MARKETING_AND_PROMOTION_MANAGEMENT",
  7: "SERALOGIN_PROCESS_LEADER_CUSTOMER_SERVICE_MANAGEMENT",
  8: "SERALOGIN_PROCESS_LEADER_FINANCIAL_AND_ACCOUNTING_MANAGEMENT",
  9: "SERALOGIN_PROCESS_LEADER_PHARMACEUTICAL_MANAGEMENT",
  10: "SERALOGIN_PROCESS_LEADER_MANAGEMENT_DIRECTION",
  11: "SERALOGIN_PROCESS_LEADER_FOREIGN_TRADE_DIRECTION",
  12: "SERALOGIN_PROCESS_LEADER_TECHNICAL_SUPPORT_DIRECTION",
  13: "SERALOGIN_PROCESS_LEADER_SAFETY_AND_HEALTH_AT_WORK",
  14: "SERALOGIN_PROCESS_LEADER_FOREIGN_TRADE_MANAGEMENT",
  15: "SERALOGIN_PROCESS_LEADER_CUSTOMER_SERVICE_PHARMADIA"
};

export const inspectionRecordProcess = {
  pending: 1,
  sent: 2,
  approved: 3
};

export const dofaTypeEnum = {
  weakness: 1,
  opportunity: 2,
  strengths: 3,
  threats: 4
};

export const strategiesTypeEnum = {
  growth: 1,
  redirect: 2,
  protection: 3,
  survive: 4
};

export const riskLevelState = {
  materialized: 1,
  closedWithoutMitigation: 2,
  accepted: 3,
  mitigated: 4,
  improved: 5,
  latent: 6
};

export const headerBannerType = {
  dofa: 1,
  riskAndOportunity: 2,
  accompaniment: 3,
  createEngineeringReport: 4,
  resume: 5,
  inspectionReport: 6,
  processMap: 7
};

export const processMapBannerContent = {
  title: "PROCESO GESTIÓN DE LA DIRECCIÓN",
  subTitle: "MAPA DE PROCESOS"
};

export const headerBannerState = {
  pending: 0,
  completed: 1
};

export const acompanimentStatus = {
  new: 0,
  inProcess: 1,
  ended: 2
};

export const historyType = {
  createOrder: 1,
  changeStateOrder: 2,
  changeEngineerOrder: 3
};

export const activityServiceOrderEnum = {
  CorrectiveMaintenance: 1,
  Setup: 2, //Alistamiento
  ConsumablesAdjustment: 3,
  PreventiveMaintenance: 4,
  AcademicActivity: 5, //Actividad académica
  PreInstallation: 6,
  Installation: 7, //Instalación
  SoftwareUpdate: 8,
  Training: 9, //Capacitación
  PredictiveVisit: 10, //Visita predictiva
  TechnicalAssist: 11 //Asistencia técnica
};

export const statesServiceOrderEnum = {
  ServiceOrderCreation: 1,
  Diagnosis: 2,
  Repair: 3,
  Testing: 4,
  EngineerinReport: 5,
  DeliveryOSClosure: 6,
  DocumentaryTechnicalPreparation: 7,
  PhysicalPreparation: 8,
  TechnicalActivity: 9,
  ServicesReport: 10,
  DiagnosisII: 11,
  RepairII: 12,
  TestingII: 13,
  Completed: 14,
  Return: 15
};

export const engineerReportTypeService = {
  CorrectiveMaintenance: 1,
  ConsumablesAdjustment: 2,
  AcademicActivity: 3,
  PreInstallation: 4,
  PreventiveMaintenance: 5,
  Installation: 6,
  SoftwareUpdate: 7,
  Training: 8,
  Other: 9
};

export const notificationStatus = {
  lapsed: 1,
  completed: 1
};

export const yesNoOptionsEnum = {
  yes: 1,
  no: 2
};

export const yesNoNaEnum = {
  yes: 1,
  no: 2,
  na: 3
};

export const analisisTableType = {
  timeAnalisis: 1,
  indicatorAnalisis: 2,
  engineeringAct: 3
};

export const engineerReportState = {
  partialSave: 1,
  complete: 2
};

export const stakeholdersTabType = {
  byProcess: 1,
  external: 2,
  internal: 3
};

export const supplierType = {
  national: 1,
  international: 2,
  services: 3
};

export const interested_parties_enter = {
  1: "Interna",
  2: "Externa"
};

export const interested_parties_RolType = {
  1: "Directa",
  2: "Permanente"
};

export const interested_parties_typeinfluence = {
  1: "Importante",
  2: "Cooperativo"
};

export const task_status_ENUM = {
  TO_DO: 1,
  IN_PROCESS: 2,
  COMPLETED: 3,
  STATE_JUSTIFIED: 4,
  DELETED: 5,
  COMPLETED_NEEDS_LEADER_REVIEW: 6
};

export const task_status_names = {
  TO_DO: "Por Hacer",
  IN_PROCESS: "En Proceso"
};

export const import_registration = {
  CURRENT: 1,
  NOT_CURRENT: 2,
  EXPIRED: 3,
  DELETED: 4
};

export const indicatorType_ENUM = {
  EXCECUTED_VS_PROJECTED: 1,
  PLANNED_NOT_EXCECUTED: 2,
  EXCECUTED_NOT_PROJECTED: 3,
  UNPLANNED_EXECUTED: 4,
  TASK_DELETED: 5
};

export const line_ENUM = {
  EXCECUTED_VS_PROJECTED: 1,
  PLANNED_NOT_EXCECUTED: 2,
  EXCECUTED_NOT_PROJECTED: 3,
  UNPLANNED_EXECUTED: 4,
  TASK_DELETED: 5
};

export const LINE_ENUM = {
  ANESTHESIA_LINE: {
    id: 5,
    label: "LINEA ANESTESIA"
  },
  MEDCAPTAIN_LINE: {
    id: 6,
    label: "MEDCAPTAIN"
  },
  HOSPITAL_LINE: {
    id: 2,
    label: "LINEA HOSPITALARIA"
  },
  PELVIC_FLOOR_LINE: {
    id: 3,
    label: "LÍNEA PISO PÉLVICO"
  },
  RED_PINE_LINE: {
    id: 4,
    label: "LINEA RED PINE"
  },
  UROLOGY_LINE: {
    id: 1,
    label: "LINEA UROLOGIA"
  }, MONITORING_LINE: {
    id: 7,
    label: "LÍNEA DE MONITOREO"
  }
};

export const causes_category = {
  INTERNATIONAL_SUPPLIER: 1,
  INTERNATIONAL_LOGISTICS: 2,
  ADUANA: 3,
  REGULATIONS: 4,
  INTERNAL: 5,
  EXTERNAL_FACTOR: 6
};
